<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div v-html="html"></div>
</template>

<script setup lang="tsx">
import { defineProps } from 'vue';
import { useTable } from '../../../hooks/use-table';

const props = defineProps<{
  tableHeaderList: any;
  tableDataList: Array<{ [key: string]: Array<string> }>;
}>();

const className = 'task-analysis-table-5';
const attrs = `border='0' bordercolor='#C0BEC7'`;
const { createTable } = useTable(props.tableHeaderList, className, attrs);
const html = createTable(props.tableDataList);
</script>
<style lang="scss">
@import '../../../styles/custom-table.scss';
$border: 2pt solid #c0bec7;
.task-analysis-table-5 {
  --header-cell-height: 50px;
  --body-cell-height: 45px;
  td {
    border-left: $border;
    border-bottom: $border;
    border-top: $border;
    &:last-child {
      border-right: $border;
    }
  }
  th {
    border-top: $border;
    border-left: $border;
    &:last-child {
      border-right: $border;
    }
    &:first-child {
      border-left: $border;
    }
  }
}
</style>
